module.exports = __webpack_public_path__ + "img/Verified - unknown.e1285e37.svg";